import * as TextVariables from '../../../assets/Variables/TextVariables'
import Colors from '../../../assets/Variables/ColorsVariables'
import { Spaces } from '../../../assets/Variables/SpaceVariables'

export const slimSelectorStyles = {
  fontFamily: TextVariables.Overline,
  borderRadius: Spaces.Size_2,
  width: '180px',
  minWidth: '160px',
  height: '44px',
  padding: '0px',
  lineHeight: 1,
  "& .MuiOutlinedInput-root": {
    borderRadius: Spaces.Size_2,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: Colors.Secondary_400,
  },
  "& .MuiSelect-select": {
    padding: `${Spaces.Size_3} 12px`,
    lineHeight: '22px',
    minHeight: '22px',
    display: 'flex',
    alignItems: 'center',
  },
}